import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BookNow = () => {
  const [form, setForm] = useState({
    firstName: '',
    email: '',
    mobile: '',
    selectedHotel: '',
    rooms: '',
    checkindate: '',
    checkoutdate: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value.trimStart()
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !form.firstName ||
      !form.email ||
      !form.mobile ||
      !form.selectedHotel ||
      !form.rooms ||
      !form.checkindate ||
      !form.checkoutdate
    ) {
      alert('Please fill in all required fields.');
      return;
    }

    try {
      const res = await axios.post(
        'https://transindiatechnologies.com/Mail/SendMail',
        form,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      alert(res.data.message || 'Email sent successfully!');
      setForm({
        firstName: '',
        email: '',
        mobile: '',
        selectedHotel: '',
        rooms: '',
        checkindate: '',
        checkoutdate: '',
        message: ''
      });
      window.scrollTo(0, 0); // Optional: scroll to top instead of reload
    } catch (err) {
      alert('Failed to send email. Please try again.');
      console.error('Email send error:', err);
    }
  };



  return (
    <>
      <div
        className="banner-header section-padding valign bg-img bg-fixed bg-position-bottom"
        data-overlay-dark="5"
        style={{ backgroundImage: `url(img/slider/book-now.jpg)` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 caption text-center">
              <h4>Get in touch</h4>
              <h1>Contact Us</h1>
            </div>
          </div>
        </div>
        <Link to="#" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section"> <span className="mouse-icon">
          <span className="mouse-wheel"></span> </span>
        </Link>
      </div>

      <section className="section-padding" data-scroll-index="1">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="img_hotel">
                <div className="item thumb">
                  <img src="img/deals.jpg" loading="lazy" alt="deals" />
                </div>

              </div>
            </div>

            <div className="col-md-7">
              <form onSubmit={handleSubmit} className="row QueryFm">
                {/* Name */}
                <div className="col-md-6 mt-1">
                  <div className="form_row">
                    <label for="Name">Name<span>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="firstName"
                      placeholder="First Name"
                      onChange={handleChange}
                      value={form.firstName}
                      required
                    />
                  </div>
                </div>

                {/* Email */}
                <div className="col-md-6 mt-1">
                  <div className="form_row">
                    <label for="Email">Email Address<span>*</span></label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Email Address"
                      onChange={handleChange}
                      value={form.email}
                      required
                    />
                  </div>
                </div>

                {/* Contact Number */}
                <div className="col-md-6 mt-1">
                  <div className="form_row">
                    <label for="Number">Contact Number<span>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="mobile"
                      placeholder="Mobile Number"
                      onChange={handleChange}
                      value={form.mobile}
                      required
                    />
                  </div>
                </div>

                {/* Hotel Selection */}
                <div className="col-md-6 mt-1">
                  <div className="form_row">
                    <label for="Hotel">Select Hotel<span>*</span></label>
                    <select
                      className="form-control form-select"
                      name="selectedHotel"
                      value={form.selectedHotel}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Hotel</option>
                      <option value="Bodhgaya Residency">Bodhgaya Residency</option>
                      <option value="Rajgir Residency">Rajgir Residency</option>
                      <option value="Vaishali Residency">Vaishali Residency</option>
                      <option value="Sravasti Residency">Sravasti Residency</option>
                    </select>
                  </div>
                </div>

                {/* Room Selection */}
                <div className="col-md-6 mt-1">
                  <div className="form_row">
                    <label for="Rooms">Rooms<span>*</span></label>
                    <select
                      className="form-control form-select"
                      name="rooms"
                      value={form.rooms}
                      onChange={handleChange}
                      required
                    >
                      <option value="">- Select Rooms -</option>
                      {[...Array(9)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {String(i + 1).padStart(2, '0')}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>



                {/* Check-in Date */}
                <div className="col-md-6 mt-1">
                  <div className="form_row">
                    <label for="Date">Check-In Date<span>*</span></label>
                    <input
                      type="date"
                      className="form-control"
                      name="checkindate"
                      onChange={handleChange}
                      value={form.checkindate}
                      required
                    />
                  </div>
                </div>

                {/* Check-out Date */}
                <div className="col-md-6 mt-1">
                  <div className="form_row">
                    <label for="Date">Check-Out Date<span>*</span></label>
                    <input
                      type="date"
                      className="form-control"
                      name="checkoutdate"
                      onChange={handleChange}
                      value={form.checkoutdate}
                      required
                    />
                  </div>
                </div>

                {/* Message */}
                <div className="col-md-12 mt-1">
                  <div className="form_row">
                    <label for="Message">Message</label>
                    <textarea
                      className="form-control"
                      name="message"
                      rows="3"
                      placeholder="Leave Comments.."
                      onChange={handleChange}
                      value={form.message}
                    ></textarea>
                  </div>
                </div>

                {/* Submit */}
                <div className="col-md-12 mt-1">
                  <button role="presentation" className="butn-dark2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookNow;